import { Dialog, DialogProps, ModalHeader } from "@/components/modal";
import { ModalMontoFieldProps } from "./types";
import MontoFieldModalForm from "./monto-field-modal-form";

interface MontoFieldModalProps extends DialogProps, ModalMontoFieldProps {

}

export default function MontoFieldModal({
    value,
    onValueChange,
    moneda,
    objective,
    objectiveFilled,
    emotionalDamage,
    allowNegative,
    decimalScale,
    ...props
}: MontoFieldModalProps) {
    return <Dialog size={objective != null ? "md" : undefined} {...props}>
        <ModalHeader>Editar Monto</ModalHeader>
        <MontoFieldModalForm
            padding={3}
            value={value}
            onValueChange={onValueChange}
            objective={objective}
            objectiveFilled={objectiveFilled}
            emotionalDamage={emotionalDamage}
            moneda={moneda}
            allowNegative={allowNegative}
        />
    </Dialog>
}